import Image from 'next/image';

import { cn } from '@/lib/utils';
import type { WindowTypeId } from '@/lib/pricing/window-cleaning-calculator';

interface WindowTypeIconProps {
  type: WindowTypeId;
  className?: string;
}

const WINDOW_EXAMPLES: Record<WindowTypeId, { src: string; width: number; height: number }> = {
  single: { src: '/images/SVG/window-examples/single.svg', width: 360, height: 250 },
  large: { src: '/images/SVG/window-examples/large.svg', width: 360, height: 250 },
  glassDoor: { src: '/images/SVG/window-examples/glass-door.webp', width: 720, height: 543 },
  frenchSingle: { src: '/images/SVG/window-examples/french-single.svg', width: 212, height: 158 },
  frenchLarge: { src: '/images/SVG/window-examples/french-large.svg', width: 212, height: 158 },
};

/**
 * Window examples. The filled panes mark the opening counted for that type.
 */
export function WindowTypeIcon({ type, className }: WindowTypeIconProps) {
  const example = WINDOW_EXAMPLES[type];

  return (
    <Image
      src={example.src}
      alt=''
      width={example.width}
      height={example.height}
      unoptimized={example.src.endsWith('.svg')}
      className={cn('h-auto w-full max-w-[12.5rem]', className)}
    />
  );
}
